import { doc, setDoc } from "firebase/firestore";
import React from "react";
import { db } from "../../../firebase";

const DeleteAttendanceController = (docId) => {
  return setDoc(
    doc(db, "Attendance", docId),
    {
      IsDeleted: true,
    },
    { merge: true }
  ).then(() => {
    return true;
  });
};

export default DeleteAttendanceController;
